import React, { useState, useEffect } from 'react';
import balanceService from '../../../utils/balanceService';
import TransactionItem from './TransactionItem';
import './TransactionHistory.css';

const TransactionHistory = ({ transactions, users, currentUser }) => {
  const [allTransactions, setAllTransactions] = useState([]);

  useEffect(() => {
    // Get all transactions from balanceService
    const persistentTransactions = balanceService.getAllTransactions();
    
    // Combine with prop transactions and remove duplicates
    const propTransactions = transactions || [];
    const combinedTransactions = [...persistentTransactions];
    
    // Add prop transactions that aren't already in persistent storage
    propTransactions.forEach(propTx => {
      const exists = persistentTransactions.some(persistentTx => persistentTx.id === propTx.id);
      if (!exists) {
        combinedTransactions.push(propTx);
      }
    });
    
    // Sort by date (newest first)
    const sortedTransactions = combinedTransactions.sort((a, b) => 
      new Date(b.created_at) - new Date(a.created_at)
    );
    
    setAllTransactions(sortedTransactions);
  }, [transactions]);

  if (!allTransactions || allTransactions.length === 0) {
    return (
      <div className="empty-history">
        <i className="fas fa-receipt"></i>
        <h3>No transaction history</h3>
        <p>Start by sending or requesting money from your friends!</p>
      </div>
    );
  }

  return (
    <div className="transaction-history">
      {allTransactions.map((transaction) => (
        <TransactionItem
          key={transaction.id}
          transaction={transaction}
          currentUser={currentUser}
          users={users}
        />
      ))}
    </div>
  );
};

export default TransactionHistory;